module.exports = __webpack_public_path__ + "img/1483721894.18978852.jpg";